// @flow

import Utils from './Utils'
import ErrorManager from './ErrorManager'
import MainConnector from './MainConnector'

/**
 *
 * TD2.X transactions management
 * @class SupplyConnector
 * @extends {MainConnector}
 */
class SupplyConnector extends MainConnector {
    documents: Array<any>

    /**
     * Default constructor
     * @param {boolean} verbose = if true verbose
     * @param {boolean} testEnv = if true test env (eg. not real life DMP)
     */
    constructor(verbose: any = false, testEnv: any = false) {
        super(verbose, testEnv)
        this.documents = []
    }

    /**
     * Structure for a document to be sent to a patient's DMP.
     * The document here is simplyfied on Performer and Author wich are always the main EsUser.HP
     * (healthcare profresionnal making the request)
     * @param {string} title
     * @param {string} description
     * @param {string} categoryCode (see main doc for list)
     * @param {Number} visibility (see main doc for list)
     * @param {Number} format (see main doc for list)
     * @param {string} contentInBase64 = the content in base64
     */
    addDocument(
        title: string,
        description: string,
        categoryCode: string,
        visibility: number,
        format: number,
        contentInBase64: string,
    ) {
        if (!this.mainParams.EsUser) {
            ErrorManager.sendError(
                'cannot add new document missing EsUser, please call setEsUser() first ! (source - initDocument)',
            )
        }

        const curDoc: any = {
            s_title: title,
            s_description: description,
            s_category: categoryCode,
            i_visibility: visibility,
            i_format: format,
            s_contentInBase64: contentInBase64,
        }

        curDoc.Performer = {}
        curDoc.Performer.HP = {
            ...this.mainParams.EsUser.HP,
        }
        curDoc.Performer.i_role = 1 // = performer is actor of act
        curDoc.Authors = [this.mainParams.EsUser.HP]

        this.documents.push(curDoc)
    }

    /**
     * Send all documents added previously to patient's DMP.
     * @param {string} insWithType = ins with type
     * @param {string} healthcareSetting defaults to '60' which maps to 'consultation and act'. Context of doc sending (see main doc for ref)
     */
    async sendDocuments(insWithType: string, healthcareSetting: string = '60'): Promise<any> {
        const requestEndPoint = 'sendsubmissionset'

        if (!Utils.checkNirOrInsIsValid(insWithType)) {
            ErrorManager.sendError('invalid ins format should be string of 15 or 16 length (source - sendDocuments)')
        }

        if (!this.documents.length) {
            ErrorManager.sendError(
                'invalid request missing documents, call initDocument first (source - sendDocuments)',
            )
        }

        const extraEndPointParams = {
            s_ins: insWithType,
            s_birthPlaceCode: insWithType.slice(5, 10), // COG code corresponding to the birth place from the ins
            s_healthcareSetting: healthcareSetting,
            Documents: [...this.documents],
        }
        const result = await this.makeRequest(requestEndPoint, extraEndPointParams)
        return result
    }
}

export default SupplyConnector
